import { Select, Button, DatePicker, Form, Input, InputNumber, Table, Typography, Popover, Tooltip, Drawer, Checkbox, message } from 'antd';
import moment from 'moment';
import React, { useMemo, useRef, useState, useEffect } from 'react'
import { FiColumns, FiEdit3, FiSave, FiXCircle } from 'react-icons/fi';
import { dateFormat, formatDate } from './Functions';
import { AvatarText } from './Functions';
import SelectDropdown from './SelectDropdown';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { HiArrowLeft } from 'react-icons/hi';
//import { Excel } from 'antd-table-saveas-excel';
import { BiColumns, BiRefresh } from 'react-icons/bi';
import { TiExport } from 'react-icons/ti';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';

const { Text } = Typography;
const { Option } = Select;

function columnTypes(type, item, value, record) {
  if (item.customRender !== undefined) {
    return item.customRender(value, record)
  }
  else {
    switch (type) {
      case 'date':
        return value !== null ? formatDate(value) : value;
      case 'avatar':
      case 'assigned_user':
        return <AvatarText name={value} />;
      default:
        return value;
    }
  }
}

function subtitleRender(item, value) {
  switch (item.subTitleType) {
    case 'trackerId':
      return value;//trackerIdNumber(value);
    default:
      return value;
  }
}

function sorterFunc(value_a, value_b, columnContent) {

  let type = columnContent !== 'date' ? typeof value_a : 'date'

  switch (type) {
    case 'number':
      return value_a - value_b;

    case 'date':
      return moment(value_a) - moment(value_b);

    default:
      return value_a.length - value_b.length;
  }
}

function renderValue(item, value, record) {
  if (item.subTitle) {
    return <div className='table-head-wrap'>
      <div className="table-head">{value}</div>
      <div className="table-subtitle">
        {subtitleRender(item, record[item.subTitle])}
      </div>
    </div>
  }
  else if (item.customRender !== undefined) {
    return item.customRender(value, record)
  }
  else {
    return value;
  }


}

function ColumnTitle({ item, filterValues, handleFilter, handleRemoveFilter, activeFilters }) {
  const { dataIndex, columnTitle, columnContent, dropdownApi } = item;

  return <div className='table-head'>
    <span className='table-head-title'>{columnTitle}</span>
    <div className='d-block' onClick={e => { e.preventDefault(); e.stopPropagation(); }}>
      <Popover
        overlayClassName='table-filter-popover'
        placement="topLeft"
        title={activeFilters[dataIndex]?.length > 0 && `${activeFilters[dataIndex]?.length} Filters Applied`}
        content={
          activeFilters[dataIndex] !== undefined &&
          activeFilters[dataIndex]?.length > 0 &&
          activeFilters[dataIndex].map((item, index) => <div onClick={() => handleRemoveFilter(dataIndex, index)}>{item}</div>)
        }
      >
        <Select
          dropdownMatchSelectWidth={false}
          maxTagCount={1}
          maxTagTextLength={5}
          maxTagPlaceholder={`+ ${activeFilters[dataIndex]?.length - 1}`}
          size='small'
          className='table-filter'
          showSearch
          placement="topLeft"
          mode='multiple'
          allowClear
          value={activeFilters[dataIndex]}
          onChange={(value) => handleFilter(dataIndex, value)}>
          {
            filterValues.map(value => <Option value={value}>{value}</Option>)
          }
        </Select>
      </Popover>
    </div>
  </div>
}


function filterOptionValues(key, data) {
  const filterOptionArray = []
  data.map(item => {
    let pushItem = item[key]
    if (!filterOptionArray.some(el => el === item[key])) {
      filterOptionArray.push(pushItem)
    }
  })
  return filterOptionArray
}

function AdvancedTable(props) {
  const { data, columns, loading, noSr, editable, putApi, refreshData, onRowClick, tableKey, title, defaultFilter, defaultFilterKey, customColumns, refreshDataButton, exportable } = props;
  //const { projectState } = useHelperContext();
  //const { userToken } = useAuth();
  //const { message } = useMsgContext();

  const [saveLoading, setSaveLoading] = useState(false);
  const [finalColumns, setFinalColumns] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [dataSource, setDataSource] = useState([]);

  //Pagination State
  const [page, setPage] = useState(0);
  const [rowCounter, setRowCounter] = useState(25);
  const [rowCount, setRowCount] = useState(25);

  const [editId, setEditId] = useState([]);
  const [editRecords, setEditRecords] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [dependency, setDependency] = useState('second')
  const dateColumns = [] //Saves Columns which is Date to Convert it to Moment for Init Data

  function handleFilter(dataIndex, value) {
    const oldActiveFilters = { ...activeFilters };
    oldActiveFilters[dataIndex] = value; //Manipulating Old Filters
    setActiveFilters(oldActiveFilters);

    const currentData = [];
    dataSource.map(record => {
      const matchFilter = Object.entries(oldActiveFilters).map(item => {
        const key = item[0];
        const appliedFilterArray = item[1];

        const match = appliedFilterArray.map((fItem) => {
          return fItem === record[key];
        })
        return match
      });

      const filterTheMatches = matchFilter.map((item) => {
        if (item.length > 0) {
          return item.includes(true);
        }
      });

      if (!filterTheMatches.includes(false)) {
        currentData.push(record)
      }
    });

    setFilteredData(currentData);
    setExportData(currentData);
  }

  function handleRemoveFilter(dIndex, idx) {
    const oldActiveFilters = { ...activeFilters };
    oldActiveFilters[dIndex].splice(idx, 1);
    setActiveFilters(oldActiveFilters);
  }

  function handleChange(value, key, id, dropdownDependent, dropdownDependentName) {
    const record = editRecords.filter((item) => item.id === id)[0];
    // const dataSourceRecordIndex = dataSource.findIndex((item) => item.id === id);
    const dataSourceRecord = dataSource.filter((item) => item.id === id)[0];

    record[key] = value;

    if (dropdownDependent) {
      dataSourceRecord[key] = value;
      dataSourceRecord[dropdownDependent] = '';
      dataSourceRecord[dropdownDependentName] = '';

      record[dropdownDependent] = '';

      let newState = editId.filter((i) => i !== id);
      setEditId(newState);

      setEditId(prevState => {
        return [...prevState, id]
      })
    }

  }

  /* function handleFilterData(newFilter){
      // console.log(newFilter);
  	
      filteredData.map(item =>{
          console.log(item)
          console.log(newFilter)
      })
      // setFilteredData(activeFilters);
  } */

  function filterOptions(key, data) {
    const filterOptionArray = []

    data.map(item => {
      let pushItem = {
        text: <Text style={{ width: 150 }} ellipsis={{ tooltip: item[key] }} > {item[key]} </Text>,
        value: item[key],
      }
      if (!filterOptionArray.some(el => el.value === item[key])) {
        filterOptionArray.push(pushItem)
      }
    })

    return filterOptionArray
  }


  function inputTypes(item, record, defaultValue) {
    const { inputNumber, columnContent, dropdownApi, key, inputDisabled, dropdownMode, inputFieldKey, dropdownDependency, dropdownDependent, dropdownDependentName } = item;
    const { id } = record;

    if (inputNumber) {
      return <InputNumber min={inputNumber.min} step={inputNumber.step} defaultValue={defaultValue} onChange={(value) => handleChange(value, key, id)} />
    }
    else if (dropdownApi) {
      // const depDataFiltered = dependencyData.filter(item => item.id === record.id)[0];
      return <>
        <SelectDropdown
          mode={dropdownMode !== undefined && dropdownMode}
          // path={dropdownDependency ? (dropdownApi + depDataFiltered.dependencyValue) : (dropdownApi)}
          path={dropdownDependency ? (dropdownApi + record[dropdownDependency]) : (dropdownApi)}
          placeholder="Select from List"
          // defaultValue={dropdownDependency ? (depDataFiltered.defaultValue) : (defaultValue)}
          defaultValue={defaultValue}
          maxTagTextLength={5}
          fieldKey={inputFieldKey}
          disabled={inputDisabled !== undefined && inputDisabled}
          onChange={(value) => handleChange(value, key, id, dropdownDependent, dropdownDependentName, dropdownDependency)}
        />
        {/* {dropdownDependency ? (dropdownApi + depDataFiltered.dependencyValue) : (dropdownApi)} */}
      </>
    }

    /* else if (columnContent === 'assigned_user') {
        return <SelectDropdown
            path={`/api/get_assigned_users/${projectState?.project_id}`}
            placeholder="Select User"
            fieldKey={['user_first_name', 'user_last_name']}
            idKey="user_id"
            mode={dropdownMode !== undefined && dropdownMode}
            defaultValue={defaultValue}
            maxTagTextLength={10}
            maxTagCount={2}
            disabled={inputDisabled !== undefined && inputDisabled}
            onChange={(value) => handleChange(value, key, id)}
        />
    } */
    else if (columnContent === 'date') {
      return <DatePicker className="w-100" defaultValue={defaultValue !== null && moment(defaultValue)} format={dateFormat} onChange={(value) => handleChange(value, key, id)} />
    }
    else {
      return <Input defaultValue={defaultValue} onChange={(e) => handleChange(e.target.value, key, id)} />
    }
  }

  function handleEditAll(e) {
    filteredData.forEach(record => {
      handleEdit(e, record);
    });
  }

  function handleCancelAll(e) {
    setEditId([])
    setEditRecords([])
  }

  function handleEdit(e, record) {
    e.stopPropagation();
    const recordId = record.id;
    const recordData = { ...record };

    if (!editId.includes(recordId)) {
      dateColumns.map(key => {
        record[key] = recordData[key] !== null ? moment(recordData[key]) : recordData[key]
      });

      setEditId(prevState => {
        return [...prevState, record.id]
      })

      setEditRecords(prevState => {
        return [...prevState, recordData]
      })
    }
    // formRef.current.setFieldsValue(record);
  }

  function handleCancel(id) {
    //Disable Edit State of an ID
    const newState = editId.filter((i) => i !== id);
    const newStateRecord = editRecords.filter((item) => item.id !== id);

    setEditRecords(newStateRecord);
    setEditId(newState);



    //Set Old Data as DataSource
    const oldDataRecord = JSON.parse(JSON.stringify(data)).filter(item => item.id === id)[0];
    const newDataSource = [...dataSource];

    const oldDataSourceIndex = newDataSource.findIndex(item => item.id === id);
    newDataSource[oldDataSourceIndex] = oldDataRecord;

    setDataSource(newDataSource);
  }

  async function handleSave(id) {
    /* let record = editRecords.filter((item) => item.id === id)[0];

    record.project_id = projectState.project_id;

    //Form Validation Before Submit
    let requiredFields = [];
    columns.map(({ dropdownDependency, required, key, columnTitle }) => {
        if (required || dropdownDependency) {
            requiredFields.push({ key, columnTitle })
        }
    });


    if (requiredFields.length > 0) {
        const checkFields = requiredFields.map(({ key, columnTitle }) => {
            if (String(record[key]).trim() === '') {
                message.error(`${columnTitle} is required field`);
                return false
            }
        });

        if (checkFields.includes(false)) {
            return
        }
    }
    //Form Validation End



    setSaveLoading(true);

    const options = {
        method: 'PUT',
        url: putApi,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userToken}`
        },
        data: record
    };

    await axios.request(options).then(async function (res) {
        handleCancel(id);
        refreshData();
        message.success('Record Updated Successfully.');
    }).catch(function (error) {
        message.error(error);
    });

    setSaveLoading(false); */
  }

  //Set Column Start
  function setColumns(columns, pageSize, page) {

    setRowCount(pageSize);

    const columnsData = columns.map(item => {

      const { dataIndex, columnContent, columnSearch, customRender, dropdownDependency, sort } = item;
      //console.log(item);
      if (dataIndex !== 'column_id') {

        //console.log(sort)
        //Sorting Function
        if (sort === false) {
          item.sorter = sort;
        }
        else {
          item.sorter = (a, b) => sorterFunc(a[dataIndex], b[dataIndex], columnContent);
        }

        item.render = (value, record) => {
          return <>
            {

              editId.includes(record.id) ?
                inputTypes(item, record, value) :

                (
                  columnContent ?
                    columnTypes(columnContent, item, value, record) :
                    renderValue(item, value, record)
                )
            }
          </>
        }





        if (columnSearch !== false) {

          //Table Filter
          item.filteredValue = activeFilters[dataIndex];
          item.onFilter = (value, record) => String(record[dataIndex]).startsWith(String(value));

          //Table Filter Input Injection
          item.title = <ColumnTitle item={item} activeFilters={activeFilters} filterValues={filterOptionValues(dataIndex, data)} handleFilter={handleFilter} handleRemoveFilter={handleRemoveFilter} />
        }

        else {
          item.title = item.columnTitle
        }

      }

      item.showColumn = item.showColumn !== undefined ? item.showColumn : true

      //Save Date Columns Record
      if (columnContent === 'date') {
        dateColumns.push(item.key)
      }

      return item
    })

    //Serial No Generate
    let indexColumn;
    if (!noSr) {
      indexColumn = [
        {
          title: ' ',
          dataIndex: 'index',
          key: 'index',
          width: 50,
          render: (value, item, index) => ((index + 1) + (page * rowCounter)),
          // render: (value, item, index) => console.log(index, pageSize, page),
        }
      ]
    } else {
      indexColumn = [

      ]
    }


    //Serial No Generate
    const actionColumn = [
      editable ? {
        // title: 'Action',
        title: <>
          Action
          <div className='table-action-all'>
            <Tooltip title="Edit All">
              <FiEdit3 onClick={(e) => handleEditAll(e)} />
            </Tooltip>

            {
              editId.length > 0 &&
              <Tooltip title="Cancel All">
                <FiXCircle onClick={(e) => handleCancelAll(e)} />
              </Tooltip>
            }
          </div>
        </>,
        key: 'action',
        fixed: 'right',
        className: 'text-center px-0',
        render: (value, record) => <div className='table-action'>
          {
            editId.includes(record.id) ?
              <div>
                <Button className='p-0 h-auto' type='link' htmlType="submit" disabled={saveLoading}>
                  {
                    saveLoading ? <LoadingOutlined /> : <FiSave className='action-save' onClick={() => handleSave(record.id)} />
                  }
                </Button>
                <FiXCircle className='action-delete' onClick={() => handleCancel(record.id)} />
              </div>
              :
              <FiEdit3 onClick={(e) => handleEdit(e, record)} />
          }
        </div>
      } : {}
    ]


    const finalColumnsData = [];
    columnsData.map(item => {
      if (item.showColumn !== false) {
        finalColumnsData.push(item)
      }
    })

    // setFinalColumns([...indexColumn, ...finalColumnsData, ...actionColumn]);
    setFinalColumns([...indexColumn, ...finalColumnsData]);
  }
  //Set Column End

  function handleClearFilters() {
    let activeFiltsTemp = {};

    columns.map(({ dataIndex }) => {
      activeFiltsTemp = { ...activeFiltsTemp, [dataIndex]: [] }
    })
    setActiveFilters(activeFiltsTemp)
  }

  //Set Columns on Mount w/ Dependency of Edit
  useMemo(() => {
    setColumns(columns, rowCounter, page);
  }, [editId, editRecords, saveLoading, dataSource, activeFilters])


  useMemo(() => {
    if (defaultFilter !== '') {
      activeFilters[defaultFilterKey] = [...defaultFilter]
      setColumns(columns, rowCounter, page);
      //console.log('defaultFilter', defaultFilter)
    }
    else {
      activeFilters[defaultFilterKey] = []
      setColumns(columns, rowCounter, page);
    }
  }, [defaultFilter])

  useEffect(() => {
    defaultFilter === '' && handleClearFilters();
    const newData = JSON.parse(JSON.stringify(data))
    setDataSource(newData);
    setExportData(newData);
    //console.log("Columns", columns);
    newData.length > 9 ? setFilteredData([...newData].splice(1, 25)) : setFilteredData(newData);

  }, [data])

  return (
    <div>
      <div className="row align-items-center mb-2">
        <div className="col">
          <div className="h5 fw-semibold mb-0">{title}</div>
        </div>
        <div className="col d-inline-flex justify-content-end align-items-center">
          {
            exportable &&
            <ExportData columns={finalColumns} exportData={exportData} title={title} />
          }

          {
            customColumns &&
            <ColumnDrawer refreshData={refreshData} tableKey={tableKey} columns={columns} />
          }

          <Button size='small' onClick={handleClearFilters}>Clear All Filters</Button>

          {
            refreshDataButton &&
            <Button size='small' className='ms-3' onClick={refreshData}><BiRefresh /></Button>

          }
        </div>
      </div>

      <Table
        className='advanced-table'
        columns={finalColumns}
        dataSource={dataSource}
        loading={loading}
        rowKey={`id`}
        showSorterTooltip={false}
        scroll={{
          x: 'max-content'
        }}
        onRow={(record) => ({
          // let { id } = record;
          onClick: (e) => !editId.includes(record.id) && onRowClick(record.id, record, e)
        })}
        onChange={(pagination, filters, sorter, extra) => {
          console.log('pagination', pagination)
          console.log('filters', filters)
          console.log('sorter', sorter)
          console.log('extra', extra)
        }}
        /* title={(currentPageData) => {
            // setFilteredData(currentPageData);
        }}
        footer={(currentPageData) => {
            // setFilteredData(currentPageData);
            // console.log('currentPageData', currentPageData);
        }} */
        pagination={{
            pageSize: 25,
          onChange(current, pageSize) {
            setPage(current - 1);
            setRowCounter(pageSize);
            setColumns(columns, rowCounter, current - 1);
          }
        }}
      >
      </Table>

      <div className='table-footer'>Showing {data.length > 9 ? rowCount : data.length} records of total {data.length}</div>
    </div>
  )
}


function ColumnDrawer({ columns, tableKey, refreshData }) {
  // const [columnData, setColumnData] = useState([])
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [initialKeys, setInitialKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  function handleDrawerClose() {
    setDrawerVisible(false)
  }

  async function handleColumnsSubmit(values) {

    /*  setLoading(true);

     if (values.columns.length === 0) {
         message.error('Atleast one column is required to show.')
         setLoading(false);
         return;
     }

     const data = {
         columns: values.columns,
         projectId: projectState.project_id,
         name: tableKey,
     };

     const options = {
         method: 'POST',
         url: `/api/table-preference/`,
         headers: {
             Authorization: `Bearer ${userToken}`
         },
         data: data
     };

     await axios.request(options).then(function (response) {
         refreshData();
         handleDrawerClose();
     }).catch(function (error) {
         message.error(error);
     });

     setLoading(false); */
  }


  function getInitialColumnKeys(column) {
    let initialColKeys = [];

    column.map(item => {
      if (item.showColumn === true) {
        initialColKeys.push(item.key);
      }
    });

    setInitialKeys(initialColKeys);
  }

  function handleSelectAll() {
    const selectAllKeys = columns.map(item => item.key);
    form.setFieldsValue({ columns: selectAllKeys })
  }
  function handleDeselectAll() {
    form.setFieldsValue({ columns: [] })
  }


  useEffect(() => {
    getInitialColumnKeys(columns)
  }, [columns])


  return (

    <>
      <Tooltip className='me-3' title='Hide / Show Columns'>
        <Button size='small' onClick={() => setDrawerVisible(true)}><BiColumns /></Button>
      </Tooltip>
      <Drawer
        className='tracker-form-drawer customize-columns-drawer'
        title="Select Columns"
        placement="right"
        onClose={handleDrawerClose}
        visible={drawerVisible}
        destroyOnClose={true}
        closeIcon={<HiArrowLeft />}
        extra={<FiColumns />}
      >
        <div className="d-flex justify-content-between mb-3">
          <Button className='me-2' block size='small' onClick={handleSelectAll}><AiOutlineCheck /> Select All</Button>
          <Button className='me-2' block size='small' onClick={handleDeselectAll}><AiOutlineClose /> Deselect All</Button>
        </div>
        <Form
          form={form}
          name='column-form'
          initialValues={{
            columns: initialKeys
          }}
          onFinish={handleColumnsSubmit}
        >
          <Form.Item name='columns'>
            <Checkbox.Group>
              {
                columns.map(item => (
                  <Checkbox className={'w-100 ' + item.className} value={item.key}>{item.columnTitle}</Checkbox>
                ))
              }
            </Checkbox.Group>
          </Form.Item>
          <div className="form-btn">
            <Button htmlType='submit' type='primary' loading={loading}>
              Update columns
            </Button>
          </div>
        </Form>
      </Drawer>
    </>

  )
}

function ExportData({ columns, exportData, title }) {
  function handleExportData() {

    let exportColumns = [];


    columns.map(item => {
      !['index', 'action'].includes(item.key) && exportColumns.push({
        title: item.columnTitle,
        dataIndex: item.dataIndex,
        key: item.key,
        width: 230
      })
    })

    /* const excel = new Excel();
    excel
        .addSheet(title)
        .addColumns(exportColumns, {

        })
        .addDataSource(exportData, {
            //str2Percent: true,
            //str2num: false
        })
        .saveAs(title + ".xlsx"); */
  }
  return (
    exportData.length > 0 &&
    <Tooltip className='me-3' title='Export Data to Excel'>
      <Button size='small' onClick={handleExportData}><TiExport /></Button>
    </Tooltip>
  )
}


export default AdvancedTable

AdvancedTable.defaultProps = {
  data: [],
  columns: [],
  loading: true,
  noSr: false,
  editable: false,
  exportable: true,
  refreshData: () => { },
  putApi: '',
  onRowClick: () => { },
  tableKey: '',
  title: '',
  defaultFilter: '',
  defaultFilterKey: '',
  customColumns: true,
  refreshDataButton: false
}